import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormattedDateTimePipe } from '../../common/pipes/formatted-date-time/formatted-date-time.pipe';
import {  FormatDateArrayPipe } from '../../common/pipes/format-date-array/format-date-array.pipe';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { SsoUserDetailsDto } from '../../common/interfaces/sso-user-details-dto';
import { InvitationSentDto } from '../../common/interfaces/invitation-sent-dto';
import { UserSsoLinkDto } from '../../common/interfaces/user-sso-link-dto';
import { SsoUserDetailsHelper } from '../../common/helpers/sso-user-details.helper';

@Component({
    selector: 'mmoa-universal-id-statuses',
    standalone: true,
    imports: [
        FormattedDateTimePipe, FormatDateArrayPipe, NgIf, EmailVerificationComponent
    ],
    templateUrl: './universal-id-statuses.component.html',
    styleUrl: './universal-id-statuses.component.scss'
})
export class UniversalIdStatusesComponent implements OnInit {
    @Input() user?: SsoUserDetailsDto | null;

    latestInvitation?: InvitationSentDto;
    oldestUserSsoLink?: UserSsoLinkDto;

    ngOnInit(): void {
        this.latestInvitation = SsoUserDetailsHelper.getLatestInvitation(this.user);
        this.oldestUserSsoLink = SsoUserDetailsHelper.getOldestUserSsoLink(this.user);
    }
}
